'use client';
import clsx from 'clsx';
import style from './sec-box.module.scss';
import { useElementSize } from '@mantine/hooks';
import { Skeleton } from '@mantine/core';

const SecBox = ({ className, children, title = 'Box Title', height: propHeight = '100%', rightSec, radius = 'lg' }) => {
    const { ref, height: titleHeight } = useElementSize(); // rename hook's height

    return (
        (children || title) && (
            <div
                className={clsx(className, style.sec_box, "site_sec_box")}
                style={{
                    height: propHeight, // use prop height here
                    borderRadius: `var(--radius-${radius})`,
                }}
            >
                {title && (
                    <div className={style.box_title} ref={ref}>
                        <h3 className={'sec_box_title'}>{title}</h3>
                        {rightSec && <div className={style.right_sec}>{rightSec}</div>}
                    </div>
                )}
                <div
                    className={style.box_content}
                    style={{
                        height: `calc(100% - ${titleHeight / 16}rem)`,
                    }}
                >
                    {children}
                </div>
            </div>
        )
    );
};

export default SecBox;

export const SecBoxLoader = () => {
    return (
        <>
            <div className={style.sec_box_loader}>
                <Skeleton className={style.skeleton} />
            </div>
        </>
    );
};
